<div class="chips-shell">
  <div class="chip" *ngFor="let chip of chips; let i = index" data-cy="localized-chip">
    <span class="chip__label">{{ chipLabel(chip) }}</span>
    <button
      type="button"
      class="chip__action"
      (click)="onTranslateChip(i)"
      [attr.aria-label]="'method_type_editor.tooltip.translate_sample_name' | translate"
      data-cy="chip-translate"
    >
      <i class="ri-translate-2" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="chip__action"
      (click)="onRemoveChip(i)"
      [attr.aria-label]="'method_type_editor.tooltip.remove_sample_name' | translate"
      data-cy="chip-remove"
    >
      <i class="ri-close-line" aria-hidden="true"></i>
    </button>
  </div>

  <input
    class="chips-shell__input"
    type="text"
    [placeholder]="placeholderKey | translate"
    (keydown)="onInputKeydown($event)"
    data-cy="chips-input"
  />
</div>
